import React from 'react';

const TaskAllocationPage = React.lazy(() => import('pages/TaskAllocation/TaskAllocationPage'));

const TaskAllocation = [
  {
    path: '/task-allocation',
    exact: true,
    name: 'Phân bổ công việc',
    function: 'CRM_TASKALLOCATION_VIEW',
    component: TaskAllocationPage,
  },
];

export default TaskAllocation;
